import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight, Clock, Sparkles } from 'lucide-react';
import { articlesApi } from '../api/client';
import { CATEGORIES } from '../mock/mock';
import SEO from '../components/SEO';

export default function Articles() {
  const [items, setItems] = useState([]);
  const [activeCat, setActiveCat] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    articlesApi.list({ limit: 60, ...(activeCat ? { category: activeCat } : {}) })
      .then(setItems)
      .finally(() => setLoading(false));
  }, [activeCat]);

  return (
    <div>
      <SEO title="Blog jurídico" description="Artigos jurídicos escritos pelos melhores escritórios do Brasil. Reforma trabalhista, LGPD, inventário, direito do consumidor e muito mais." />

      <div className="bg-white border-b border-[#cbd8dc] text-[#122f36]">
        <div className="aj-wrap py-14">
          <nav className="text-xs text-[#52676e] mb-4"><Link to="/" className="hover:text-[#063f4c]">Início</Link> / Blog jurídico</nav>
          <div className="flex flex-wrap items-center gap-3 mb-2">
            <div className="inline-flex items-center gap-2 bg-[#edf4f5] border border-[#cbd8dc] rounded-full px-3 py-1 text-xs font-medium text-[#075a6d]">
              <Sparkles className="w-3 h-3" /> Conteúdo por advogados especialistas
            </div>
          </div>
          <h1 className="text-3xl md:text-4xl font-semibold">Blog jurídico</h1>
          <p className="text-[#354c54] mt-2 max-w-2xl">Artigos escritos pelos melhores escritórios do Brasil. Informação de qualidade sobre direito e cidadania.</p>
        </div>
      </div>

      {/* Category tabs */}
      <div className="bg-white border-b border-[#cbd8dc] sticky top-16 z-30">
        <div className="aj-wrap py-3 overflow-x-auto">
          <div className="flex items-center gap-2 whitespace-nowrap">
            <button onClick={() => setActiveCat('')} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${!activeCat ? 'bg-[#153e44] text-white' : 'bg-[#f2f6f7] text-[#354c54] hover:bg-[#e1e9eb]'}`}>Todas</button>
            {CATEGORIES.map(c => (
              <button key={c.slug} onClick={() => setActiveCat(c.slug)} className={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${activeCat === c.slug ? 'bg-[#153e44] text-white' : 'bg-[#f2f6f7] text-[#354c54] hover:bg-[#e1e9eb]'}`}>{c.name}</button>
            ))}
          </div>
        </div>
      </div>

      <div className="aj-wrap py-12">
        {loading ? (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[1,2,3,4,5,6].map(i => <div key={i} className="bg-white rounded-[10px] border border-[#cbd8dc] h-96 animate-pulse" />)}
          </div>
        ) : items.length === 0 ? (
          <div className="bg-white border border-[#cbd8dc] rounded-[10px] p-12 text-center text-[#52676e]">Nenhum artigo publicado nesta categoria ainda.</div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {items.map(art => {
              const Wrapper = art.externalUrl ? 'a' : Link;
              const wrapProps = art.externalUrl ? { href: art.externalUrl, target: '_blank', rel: 'noopener noreferrer' } : { to: `/artigo/${art.firmSlug}/${art.id}` };
              return (
              <Wrapper {...wrapProps} key={`${art.firmSlug}-${art.id}`} className="bg-white rounded-[10px] border border-[#cbd8dc] overflow-hidden hover:border-[#547a83] transition-shadow group">
                {art.cover && (
                  <div className="aspect-[16/9] overflow-hidden bg-[#f2f6f7]">
                    <img src={art.cover} alt={art.title} loading="lazy" className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                  </div>
                )}
                <div className="p-5">
                  <div className="flex items-center gap-2 text-xs text-[#52676e] mb-2">
                    <span>{art.date}</span><span>•</span>
                    <Clock className="w-3 h-3" /><span>{art.readTime}</span>
                  </div>
                  <h3 className="font-semibold text-[#153e44] leading-snug group-hover:text-[#075a6d] transition-colors line-clamp-2">{art.title}</h3>
                  <p className="text-sm text-[#425a62] mt-2 line-clamp-2">{art.excerpt}</p>
                  <div className="mt-4 flex items-center gap-2 text-xs text-[#52676e]">
                    {art.firmPhoto && <img src={art.firmPhoto} alt="" className="w-6 h-6 rounded-full object-cover" />}
                    <span>Por <span className="font-medium text-[#153e44]">{art.author || art.firmName}</span></span>
                    <ChevronRight className="w-3 h-3 ml-auto" />
                  </div>
                </div>
              </Wrapper>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}
